import React from 'react';

export default function TableRowLoader({ numColumns }) {
  const cells = Array.from({ length: numColumns }).fill();

  return (
    <li className="min-h-[98px] w-full grid grid-cols-3">
      {cells.map((_, index) => (
        <div
          key={`TableLoader-${index}`}
          className="whitespace-nowrap py-4 px-3"
        >
          <div className="h-10 w-full px-6 animate-pulse space-x-4 bg-primary rounded" />
        </div>
      ))}
    </li>
  );
}
